// extracted by mini-css-extract-plugin
module.exports = {"popupTokuten":"ShopBenefit_popupTokuten__6FuD8"};